import '@fountain/ripple/styles';

import * as Sentry from '@sentry/react';
import { OpenAPI } from 'api-clients/monolith';
import React from 'react';
import ReactDOM from 'react-dom';

import { domainMeta } from 'utils/domainMeta';
import { initSentry } from 'utils/sentry';

import { getDirection, setBodyDirection } from './direction';
import { Root } from './root';

// Before the first render, so a failure during bootstrap is reported.
initSentry();

// Load Direction settings
const direction = getDirection();
setBodyDirection(direction);

// Setup OpenApi client
OpenAPI.BASE = domainMeta.monolithOrigin;

const MOUNT_NODE = document.getElementById('app');

ReactDOM.render(
  <React.StrictMode>
    {/*
      A render error already blanks the portal out, because React unmounts the
      tree it cannot recover. The boundary keeps that behavior — no `fallback`,
      so it renders nothing — and adds the report React does not send.
    */}
    <Sentry.ErrorBoundary>
      <Root />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  MOUNT_NODE,
);
